import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader';
import CONSTANTS from '../../constants';
import { GcpCertRejectionRequest } from '../../types/gcpCert'

const { GCPCERTS_API_URL } = CONSTANTS;

const rejectCert = async (rejectionRequest: GcpCertRejectionRequest): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
			'Content-Type': 'application/json',
			action: 'REJECT'
		},
    body: JSON.stringify(rejectionRequest),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Failed to reject certificate: ${message}`);
  }

  return response.json();
};

export default rejectCert